import type { App } from 'vue'

export default {
    install: () => {
        if (process.env.COOKIEYES_DISALLOW === '1') {
            return
        }
        const script = document.createElement('script')
        script.id = 'cookieyes'
        script.type = 'text/javascript'
        script.async = true
        script.src = 'https://cdn-cookieyes.com/client_data/94bb4570c6cff56b8ef7314b/script.js'
        document.head.appendChild(script)
    },
}
